module.exports = __webpack_public_path__ + "img/49800.e04efdcc.jpg";